"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect } from "react";

/** Hook to handle Cmd/Ctrl+O keyboard shortcut for backup import */
export function useImportShortcut(isMac, loading) {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] !== isMac || $[1] !== loading) {
    t0 = () => {
      const handleKeyDown = event => {
        const openKey = event.key.toLowerCase() === "o";
        const modifier = isMac ? event.metaKey : event.ctrlKey;
        if (!(modifier && openKey)) {
          return;
        }
        if (loading) {
          return;
        }
        event.preventDefault();
        document.getElementById("backup-import")?.click();
      };
      window.addEventListener("keydown", handleKeyDown);
      return () => window.removeEventListener("keydown", handleKeyDown);
    };
    t1 = [isMac, loading];
    $[0] = isMac;
    $[1] = loading;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  useEffect(t0, t1);
}